import * as o from "react";
import { c as r } from "../createReactComponent-58f9bea8.mjs";
import { c as e, r as a } from "../loader-8e6cf7b9.mjs";
import { d as C, L as g, b, a as y, S as z } from "../loader-8e6cf7b9.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
import "../style-map-c3339321.mjs";
import "../icon-c572aa57.mjs";
import "../icon-button-87ac6b5d.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const S = r({ tagName: "ex-loader", elementClass: e, react: o, events: { onClose: "onClose", onRestart: "onRestart" }, displayName: "ExLoader", registerWebComponent: a });
export {
  S as ExLoader,
  C as LoaderFooterType,
  g as LoaderSize,
  b as LoaderState,
  y as LoaderVariant,
  z as SpinnerSize,
  a as register
};
